import React from 'react';
import { IoAdd } from 'react-icons/io5';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebounce } from 'usehooks-ts';
import { useTranslation } from 'react-i18next';
import styles from './list.module.scss';

import InputSearch from '../../../components/InputSearch';
import { useCreateFormation, useGetFormations, useGetFormationsList } from '../../../hooks/formations';

import FormationsTable from '../../../components/FormationsTable';
import ButtonExpandable from '../../../components/ButtonExpandable';
import FilterSearchParam from '../../../components/FilterSearchParam';
import { IFormation } from '../../../types/formations';
import useTagsToOptionsLang from '../../../hooks/useTagsToOptionsLang';

const Formations = () => {
  const { t } = useTranslation('formations');
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { search = '', ...paramsObject } = Object.fromEntries(searchParams);
  const debouncedSearch = useDebounce<string>(search, 500);
  const { data: list } = useGetFormationsList();
  const { data: dataFormations = [], isLoading } = useGetFormations({
    ...paramsObject,
    search: debouncedSearch,
  });
  const {
    mutateAsync: createFormation,
    error: errorPost,
  } = useCreateFormation();

  const errorApi: any = errorPost;
  console.log(errorApi);

  const formations : IFormation[] = dataFormations || [];

  const tags = useTagsToOptionsLang(list?.tags || []);

  const handleSearch = (searchValue: string) => {
    const params = new URLSearchParams(searchParams);
    if (searchValue.length < 3) {
      params.delete('search');
    } else {
      params.set('search', searchValue);
    }
    setSearchParams(params);
  };

  const handleSorting = (sort: any) => {
    if (!sort) return;
    const params = new URLSearchParams(searchParams);
    params.set('sortKey', sort.id.replace('_', '.'));
    params.set('order', sort.desc ? 'desc' : 'asc');
    setSearchParams(new URLSearchParams(params));
  };

  const handleCreateFormation = async () => {
    const data = { name: t('new-formation') };
    const { formation: createdFormation }: any = await createFormation(data);
    if (createdFormation) navigate(`/formation/edit/${createdFormation?._id}`);
  };

  return (
    <div className={styles.listFormations}>
      <div className={styles.header}>
        <h1>
          {t('title')}
          {formations.length > 0 && 's'}
          <span>{formations.length}</span>
        </h1>
        <div>
          <InputSearch
            handleSearch={handleSearch}
            defaultValue={search}
          />
          <div
            onClick={() => handleCreateFormation()}
          >
            <ButtonExpandable
              icon={<IoAdd size={24} />}
              text={t('new-formation')}
            />
          </div>
        </div>
      </div>
      {isLoading && <p>Loading</p>}
      <div className={styles.filters}>
         <FilterSearchParam
          label={t('filters.tags')}
          name='tag'
          options={tags || []}
        />
      </div>
      {formations.length > 0 && (
        <FormationsTable
          formations={formations}
          handleSorting={handleSorting}
        />
      )}
    </div>
  );
};

export default Formations;
